import React, { Component } from 'react'
import { FooterStyle, Shadow } from './style'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from 'configs/config'
import { objToArr, overflowBodyRemove, overflowBodyAdd } from 'utils/common'
import FooterNav from './components/FooterNav'
import { skipWasReasonAdded, getPartialSteps } from 'components/Steps/thunk'
import { setStepsToDefault, cleanItems } from '../Steps/slices'
import { updateContinueState, showFooterBlock, hideFooterBlock } from './thunk'
import _ from 'lodash'
import { withRouter } from 'react-router'
import { getCartFinal } from 'containers/Refund/thunk'
import AlertBottom from '../Alerts/AlertBottom'
import { startCheckReturnMandatoryFields } from 'containers/Return/thunk'
import { startCheckComplaintMandatoryFields } from 'containers/Reclamation/thunk'
import Cart from './components/Cart'
import { setItemsAsHandled } from './slices'
import { clearState } from '../../containers/Refund/slices'

class Footer extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: false,
		}

		this.setIsOpen = this.setIsOpen.bind(this)
	}

	/**
	 * setIsOpen {Function}
	 * @description - change item state responsible to expand/collapse the footer element
	 *
	 * */
	setIsOpen(isOpen) {
		this.setState({
			isOpen,
		})
		if (isOpen) {
			overflowBodyAdd()
		} else {
			overflowBodyRemove()
		}
	}

	/**
	 * getQuantityItem {Function}
	 * @description - get items length currently selected in cart
	 * @return {Number}
	 *
	 * */
	getQuantityItem() {
		let { items } = this.props
		let listItem = objToArr(items)

		return listItem?.length
	}

	/**
	 * getListItem {Function}
	 * @description - transform item object from the cart to the array, to display them into cart as slider
	 * @return {Array}
	 *
	 * */
	getListItem() {
		let { items } = this.props

		return objToArr(items)
	}

	/**
	 * getCurrencyItem {Function}
	 * @description - get current currency
	 * @return {String || undefined}
	 *
	 * */
	getCurrencyItem() {
		let { items } = this.props
		let listItem = objToArr(items)

		return listItem[0]?.currency
	}

	isContinueActive = () => {
		let { isContinueActive, flowStep } = this.props
		let isActive = false

		if (flowStep === config.flowSteps.SELECT) {
			isActive = true
		} else {
			isActive = isContinueActive
		}

		return isActive
	}

	areAnyItems = (items) => {
		let areAnyItems = false

		for (let key in items) {
			if (items.hasOwnProperty(key)) {
				let currentItemsFlow = items[key]
				if (!_.isEmpty(currentItemsFlow)) {
					areAnyItems = true
				}
			}
		}

		return areAnyItems
	}

	/**
	 * getSpecificAction {Function}
	 * @description - detect what action need to be call based on what step we currently are.
	 * @return {Function}
	 *
	 * */
	getSpecificAction = () => {
		let { flowStep } = this.props
		let upperCaseFlowStep = flowStep.toUpperCase()

		switch (upperCaseFlowStep) {
			case 'RETURN':
				this.props.startCheckReturnMandatoryFields()
				break
			case 'COMPLAINT':
				this.props.startCheckComplaintMandatoryFields()
				break
			default:
				console.log(upperCaseFlowStep)
				break
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let {
			flowStep,
			items,
			history,
			partialRequestData,
			wasItemsHandled,
			cartStateChanged,
		} = this.props
		/*if (
            prevProps.flowStep !== flowStep &&
            flowStep === config.flowSteps.EXCHANGE
        ) {
            this.props.updateContinueState(false)
        }*/
		if (prevProps.flowStep !== flowStep) {
			overflowBodyRemove()
		}

		if (
			prevProps.wasItemsHandled !== wasItemsHandled &&
			wasItemsHandled &&
			(flowStep === config.flowSteps.RETURN ||
				flowStep === config.flowSteps.EXCHANGE ||
				flowStep === config.flowSteps.COMPLAINT)
		) {
			this.props.clearState()
			this.props.cleanItems()
			this.props.setItemsAsHandled(false)
		}

		if (prevProps.items !== items) {
			if (this.areAnyItems(items)) {
				let isAnyToReturn = Object.keys(items.refund).length
				let isAnyToComplaint = Object.keys(items.reclamation).length
				//let isAnyToExchange = Object.keys(items.exchange).length

				if (flowStep === config.flowSteps.RETURN && !isAnyToReturn) {
					if (isAnyToComplaint) {
						this.props.getPartialSteps(partialRequestData)
						history.push('/complaint')
					}
				}

				if (
					flowStep === config.flowSteps.COMPLAINT &&
					!isAnyToComplaint
				) {
					if (isAnyToReturn) {
						this.props.getPartialSteps(partialRequestData)
						history.push('/return')
					}
				}

				/*if (
                    flowStep === config.flowSteps.EXCHANGE &&
                    !isAnyToExchange
                ) {
                    if (isAnyToComplaint) {
                        this.props.getPartialSteps(partialRequestData)
                        history.push('/complaint')
                    }

                    if (isAnyToReturn) {
                        this.props.getPartialSteps(partialRequestData)
                        history.push('/return')
                    }
                }*/

				this.props.showFooterBlock()
			} else {
				if (flowStep !== config.flowSteps.SELECT) {
					this.props.cleanItems()
					history.push('/orders')
				}
				this.props.hideFooterBlock()
			}
		}

		if (prevProps.cartStateChanged !== cartStateChanged) {
			this.setState({
				isOpen: false,
			})
		}
	}

	componentDidMount() {
		let { items } = this.props
		if (this.areAnyItems(items)) {
			this.props.showFooterBlock()
		}
	}

	render() {
		let {
			totals,
			isFooterVisible,
			continueUrl,
			partialRequestData,
			flowStep,
			backUrl,
			nextFlowStep,
		} = this.props
		let { isOpen } = this.state
		let quantityItem = this.getQuantityItem()
		let listItem = this.getListItem()
		let currentCurrency =
			listItem && listItem.length ? listItem[0].currency : ''
		let exchangeList = listItem.filter((i) => {
			if (i.keyVariant) {
				return i.variants[i.keyVariant]
			}
			return false
		})

		return (
			<FooterStyle
				isVisible={isFooterVisible}
				className='container p-0'
				onClick={() => this.setIsOpen(!isOpen)}
				id='returnado-widget-footer'
			>
				<Shadow isVisible={isFooterVisible} isOpen={isOpen} />
				<AlertBottom />
				<Cart
					isOpen={isOpen}
					isFooterVisible={isFooterVisible}
					quantityItem={quantityItem}
					listItem={listItem}
					exchangeList={exchangeList}
					totals={totals}
					currency={currentCurrency}
				/>
				<FooterNav
					isOpen={isOpen}
					continueUrl={continueUrl}
					partialRequestData={partialRequestData}
					flowStep={flowStep}
					nextFlowStep={nextFlowStep}
					backUrl={backUrl}
					totals={totals}
					quantityItem={quantityItem}
					currency={currentCurrency}
					setIsOpen={this.setIsOpen}
					getCartFinal={this.props.getCartFinal}
					getSpecificAction={this.getSpecificAction}
					isContinueActive={this.isContinueActive}
				/>
			</FooterStyle>
		)
	}
}

function mapStateToProps({ root, steps, router, footer }) {
	return {
		...root,
		...steps,
		...router,
		...footer,
	}
}

function matchDispatchToProps(dispatcher) {
	return bindActionCreators(
		{
			setStepsToDefault,
			skipWasReasonAdded,
			updateContinueState,
			showFooterBlock,
			hideFooterBlock,
			getCartFinal,
			startCheckReturnMandatoryFields,
			startCheckComplaintMandatoryFields,
			getPartialSteps,
			cleanItems,
			setItemsAsHandled,
			clearState,
		},
		dispatcher
	)
}

export default connect(
	mapStateToProps,
	matchDispatchToProps
)(withRouter(Footer))
